<template>
  <div>
    <input
      :id="data.id.toString()"
      :value="data.value"
      :name="name"
      :class="{ invalid: meta.touched && !meta.valid }"
      type="radio"
      @change="$emit('update:modelValue', data.value)"
      :checked="modelValue === data.value"
    />
    <label :for="data.id.toString()" :data-test-base-radio-image="data.name">
      {{ data.label }}<br />
      <img v-if="data.imgSrc !== null" :src="data.imgSrc" :alt="data.alt" />
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import BaseRadioImageOption from './interfaces/BaseRadioImageOption';

export default defineComponent({
  name: 'BaseRadioImage',
  emits:['update:modelValue'],
  props: {
    name: {
      type: String,
      default() {
        return 'base-radio-image';
      }
    },
    data: {
      type: Object as PropType<BaseRadioImageOption>,
      default() {
        return {
          id: 1,
          name: '',
          label: '',
          imgSrc: '',
          alt: '',
          value: ''
        };
      }
    },
    meta: {
      type: Object,
      default() {
        return {};
      }
    },
    modelValue: {
      type: [ Object, String ],
      default() {
        return null;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.radio-inline {
  [type='radio'] {
    & + label {
      &:before {
        margin-top: rem-calc(-5);
      }

      img {
        padding: rem-calc(10);
        margin: rem-calc(5) 0 0 0;
        border: rem-calc(3) solid $white;
        border-radius: rem-calc(10);

        &:hover {
          border-color: $light-gray;
        }
      }
    }
    &:checked {
      & + label {
        img {
          border-color: $secondary-color;
        }
      }
    }
    &.invalid {
      & + label {
        img {
          border-color: $input-error-border;
        }
      }
    }
  }
}
</style>
